
const scrollDistance = 1000; // px

export const initScrollTopBtn = () => {
    let element = document.createElement('div');
    let icon = document.createElement('span');

    element.classList.add('scroll-top-btn');
    icon.classList.add('scroll-top-icon');
    // icon.classList.add('scroll-top-icon', 'icon-arrow-right');

    // icon.innerHTML = '<span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span>';

    element.addEventListener('click', scrollTop);

    window.addEventListener('scroll', () => {
        const scrollHeight = window.scrollY;
    
        if(scrollHeight >= scrollDistance) element.classList.add('show');
        else element.classList.remove('show');
    });
    
    element.appendChild(icon);
    document.body.appendChild(element);
};

const scrollTop = () => {
    let privadaEl = document.querySelector('#create-account');
    let distance = 0;

    if(privadaEl)
        distance = document.querySelector(privadaEl).getBoundingClientRect().top;

    scroll({
        top: distance,
        behavior: "smooth"
    });
};